import type { SerializedRichBlockNode } from "@resource/atlas/content-editor/__utils/rich-blocks";

import type { PersistableCalendarEvent } from "./calendar-utils/types";

// config
// ------

export const RICH_BLOCK_NAME = "request-availability";

export const DEFAULT_DATA: RequestAvailabilityData = {
  availabilityRequestId: "",
  senderSuggestions: [],
  title: "",
  description: "",
  duration: 0,
  createMultipleEventsOnDrag: false,
  forceResponsesInIncrements: false,
  overlayCalendars: false,
  calendars: [],
  allowSelectionOutsideSuggestions: true,
  edited: false,
  timezone: "",
};

export const labelForDuration = (duration: number) => {
  switch (duration) {
    case 0:
      return "Any length";
    case 15:
      return "15 minutes";
    case 30:
      return "30 minutes";
    case 45:
      return "45 minutes";
    case 60:
      return "1 hour";
    case 90:
      return "90 minutes";
    case 120:
      return "2 hours";
    case 180:
      return "3 hours";
    case 240:
      return "Half day";
    case 480:
      return "Full day";
    default:
      return "Custom";
  }
};

// types
// -----

export type RequestAvailabilityName = typeof RICH_BLOCK_NAME;

export type RequestAvailabilityData = {
  availabilityRequestId: string;
  senderSuggestions: PersistableCalendarEvent[];
  title: string;
  description: string;
  duration: number;
  createMultipleEventsOnDrag: boolean;
  forceResponsesInIncrements: boolean;
  overlayCalendars: boolean;
  calendars: string[];
  allowSelectionOutsideSuggestions: boolean;
  edited: boolean;
  timezone: string;
  candidate?: {
    name: string;
  };
  organization?: {
    name: string;
    avatarUrl: string;
  };
};

export type SerializedRequestAvailabilityNode = SerializedRichBlockNode<
  RequestAvailabilityName,
  RequestAvailabilityData
>;

export type MeetingDuration =
  | 0
  | 15
  | 30
  | 45
  | 60
  | 90
  | 120
  | 180
  | 240
  | 480;
